import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import AboutPreview from './components/AboutPreview';
import DivisionsPreview from './components/DivisionsPreview';
import InvestmentTiers from './components/InvestmentTiers';
import DigitalAssetsPreview from './components/DigitalAssetsPreview';
import CTASection from './components/CTASection';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <HeroSection />
      <AboutPreview />
      <DivisionsPreview />
      <InvestmentTiers />
      <DigitalAssetsPreview />

      {/* Eco-Friendly & Sustainable Business */}
      <section className="py-16 sm:py-24 bg-gradient-to-b from-white to-primary-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12 sm:mb-16">
            <div className="inline-flex items-center space-x-2 px-4 py-2 bg-primary-100 rounded-full mb-6">
              <i className="ri-recycle-line text-primary-600"></i>
              <span className="text-sm text-primary-700 font-medium">Sustainable Economic Business Circle</span>
            </div>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-display font-bold text-gray-900 mb-4 sm:mb-6">
              Closed-Loop Ecosystem
            </h2>
            <p className="text-base sm:text-xl text-gray-600 max-w-3xl mx-auto">
              All six divisions operate within a <strong>Sustainable Economic Business Circle</strong> — each company feeds into the next, creating a self-reinforcing closed-loop ecosystem that maximises efficiency and minimises waste
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-8">
            <div className="bg-white border border-primary-100 rounded-2xl p-8 text-center hover:shadow-xl transition-all hover:-translate-y-1">
              <div className="w-16 h-16 flex items-center justify-center bg-primary-100 rounded-full mx-auto mb-6">
                <i className="ri-plant-line text-3xl text-primary-600"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">Palm Oil &rarr; Manufacturing</h3>
              <p className="text-sm text-gray-600">Raw palm oil from Drixem Mega flows directly into Drixem Nexus Manufacturing for packaging and bottling — zero supply chain gaps.</p>
            </div>

            <div className="bg-white border border-primary-100 rounded-2xl p-8 text-center hover:shadow-xl transition-all hover:-translate-y-1">
              <div className="w-16 h-16 flex items-center justify-center bg-primary-100 rounded-full mx-auto mb-6">
                <i className="ri-ship-line text-3xl text-primary-600"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">Manufacturing &rarr; Export</h3>
              <p className="text-sm text-gray-600">Finished products are exported globally through Aravion Zeus, leveraging established trade routes across five continents.</p>
            </div>

            <div className="bg-white border border-primary-100 rounded-2xl p-8 text-center hover:shadow-xl transition-all hover:-translate-y-1">
              <div className="w-16 h-16 flex items-center justify-center bg-primary-100 rounded-full mx-auto mb-6">
                <i className="ri-megaphone-line text-3xl text-primary-600"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">Marketing &rarr; All Divisions</h3>
              <p className="text-sm text-gray-600">Drixem Sdn Bhd provides branding, advertising, and marketing services to all group companies — keeping expertise in-house.</p>
            </div>

            <div className="bg-white border border-primary-100 rounded-2xl p-8 text-center hover:shadow-xl transition-all hover:-translate-y-1">
              <div className="w-16 h-16 flex items-center justify-center bg-primary-100 rounded-full mx-auto mb-6">
                <i className="ri-robot-line text-3xl text-primary-600"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">Physical AI &rarr; All Divisions</h3>
              <p className="text-sm text-gray-600">Nexa Prime embeds Physical AI across every division — automating logistics, optimising production, and enhancing decision-making at scale.</p>
            </div>

            <div className="bg-white border border-primary-100 rounded-2xl p-8 text-center hover:shadow-xl transition-all hover:-translate-y-1">
              <div className="w-16 h-16 flex items-center justify-center bg-primary-100 rounded-full mx-auto mb-6">
                <i className="ri-building-line text-3xl text-primary-600"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">Property &rarr; Asset Growth</h3>
              <p className="text-sm text-gray-600">Heuliez develops strategic properties that house group operations — turning real estate into productive business infrastructure.</p>
            </div>

            <div className="bg-white border border-primary-100 rounded-2xl p-8 text-center hover:shadow-xl transition-all hover:-translate-y-1">
              <div className="w-16 h-16 flex items-center justify-center bg-primary-100 rounded-full mx-auto mb-6">
                <i className="ri-recycle-line text-3xl text-primary-600"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">Revenue &rarr; Reinvestment</h3>
              <p className="text-sm text-gray-600">Profits from each division are reinvested across the ecosystem, fuelling continuous growth and compounding returns for investors.</p>
            </div>
          </div>

          <div className="mt-8 sm:mt-12 bg-white border border-primary-200 rounded-2xl p-6 sm:p-8 md:p-12">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 sm:gap-8 text-center">
              <div>
                <div className="text-3xl sm:text-4xl font-bold text-primary-600 mb-2">100%</div>
                <p className="text-gray-600 text-xs sm:text-sm">MPOB &amp; JAKIM Halal Certified Operations</p>
              </div>
              <div>
                <div className="text-3xl sm:text-4xl font-bold text-primary-600 mb-2">ESG</div>
                <p className="text-gray-600 text-xs sm:text-sm">Environmental, Social &amp; Governance Focused</p>
              </div>
              <div>
                <div className="text-3xl sm:text-4xl font-bold text-primary-600 mb-2">SDG</div>
                <p className="text-gray-600 text-xs sm:text-sm">Aligned with UN Sustainable Development Goals</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <CTASection />
      <Footer />
    </div>
  );
};

export default HomePage;